import { jsx as S } from "react/jsx-runtime";
import * as a from "react";
import Pn, { useLayoutEffect as wn, useState as Sn } from "react";
import { r as je } from "../../index-CJ0TdoNN.js";
import { c as Cn, o as Rn, s as On, f as xn, a as An, h as _n, b as tt, l as Dn, d as Nn } from "../../floating-ui.dom-BYR49O0v.js";
import { cn as Tn } from "../../utils/cn.js";
var Mn = Object.defineProperty, oe = (e, t) => Mn(e, "name", { value: t, configurable: !0 }), vt = !!(typeof window < "u" && window.document && window.document.createElement);
function V(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return /* @__PURE__ */ oe(function(o) {
    if (e?.(o), n === !1 || !o || !o.defaultPrevented)
      return t?.(o);
  }, "handleEvent");
}
oe(V, "composeEventHandlers");
function In(e) {
  if (!vt)
    throw new Error("Cannot access window outside of the DOM");
  return e?.ownerDocument?.defaultView ?? window;
}
oe(In, "getOwnerWindow");
function De(e) {
  if (!vt)
    throw new Error("Cannot access document outside of the DOM");
  return e?.ownerDocument ?? document;
}
oe(De, "getOwnerDocument");
function mt(e, t = !1) {
  const { activeElement: n } = De(e);
  if (!n?.nodeName)
    return null;
  if (ht(n) && n.contentDocument)
    return mt(n.contentDocument.body, t);
  if (t) {
    const r = n.getAttribute("aria-activedescendant");
    if (r) {
      const o = De(n).getElementById(r);
      if (o)
        return o;
    }
  }
  return n;
}
oe(mt, "getActiveElement");
function ht(e) {
  return e.tagName === "IFRAME";
}
oe(ht, "isFrame");
var Fn = Object.defineProperty, Be = (e, t) => Fn(e, "name", { value: t, configurable: !0 });
function Ne(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
Be(Ne, "setRef");
function gt(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Ne(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Ne(e[o], null);
        }
      };
  };
}
Be(gt, "composeRefs");
function Y(...e) {
  return a.useCallback(gt(...e), e);
}
Be(Y, "useComposedRefs");
var kn = Object.defineProperty, M = (e, t) => kn(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function Ln(e, t) {
  const n = a.createContext(t);
  n.displayName = e + "Context";
  const r = /* @__PURE__ */ M((i) => {
    const { children: s, ...c } = i, u = a.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ S(n.Provider, { value: u, children: s });
  }, "Provider");
  r.displayName = e + "Provider";
  function o(i, s = {}) {
    const { optional: c = !1 } = s, u = a.useContext(n);
    if (u) return u;
    if (t !== void 0) return t;
    if (!c)
      throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return M(o, "useContext"), [r, o];
}
M(Ln, "createContext");
// @__NO_SIDE_EFFECTS__
function Ue(e, t = []) {
  let n = [];
  function r(i, s) {
    const c = a.createContext(s);
    c.displayName = i + "Context";
    const u = n.length;
    n = [...n, s];
    const v = /* @__PURE__ */ M((l) => {
      const { scope: f, children: g, ...m } = l, p = f?.[e]?.[u] || c, h = a.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ S(p.Provider, { value: h, children: g });
    }, "Provider");
    v.displayName = i + "Provider";
    function d(l, f, g = {}) {
      const { optional: m = !1 } = g, p = f?.[e]?.[u] || c, h = a.useContext(p);
      if (h) return h;
      if (s !== void 0) return s;
      if (!m)
        throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return M(d, "useContext"), [v, d];
  }
  M(r, "createContext");
  const o = /* @__PURE__ */ M(() => {
    const i = n.map((s) => a.createContext(s));
    return /* @__PURE__ */ M(function(c) {
      const u = c?.[e] || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: u } }),
        [c, u]
      );
    }, "useScope");
  }, "createScope");
  return o.scopeName = e, [r, yt(o, ...t)];
}
M(Ue, "createContextScope");
function yt(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = /* @__PURE__ */ M(() => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return /* @__PURE__ */ M(function(i) {
      const s = r.reduce((c, { useScope: u, scopeName: v }) => {
        const l = u(i)[`__scope${v}`];
        return { ...c, ...l };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    }, "useComposedScopes");
  }, "createScope");
  return n.scopeName = t.scopeName, n;
}
M(yt, "composeContextScopes");
var $n = Object.defineProperty, L = (e, t) => $n(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function ze(e) {
  const t = a.forwardRef((n, r) => {
    let { children: o, ...i } = n, s = null, c = !1;
    const u = [];
    Te(o) && typeof le == "function" && (o = le(o._payload)), a.Children.forEach(o, (f) => {
      if (wt(f)) {
        c = !0;
        const g = f;
        let m = "child" in g.props ? g.props.child : g.props.children;
        Te(m) && typeof le == "function" && (m = le(m._payload)), s = jn(g, m), u.push(s?.props?.children);
      } else
        u.push(f);
    }), s ? s = a.cloneElement(s, void 0, u) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !c && a.Children.count(o) === 1 && a.isValidElement(o) && (s = o)
    );
    const v = s ? Pt(s) : void 0, d = Y(r, v);
    if (!s) {
      if (o || o === 0)
        throw new Error(
          c ? zn(e) : Un(e)
        );
      return o;
    }
    const l = Et(i, s.props ?? {});
    return s.type !== a.Fragment && (l.ref = r ? d : v), a.cloneElement(s, l);
  });
  return t.displayName = `${e}.Slot`, t;
}
L(ze, "createSlot");
var bt = /* @__PURE__ */ Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Wn(e) {
  const t = /* @__PURE__ */ L((n) => "child" in n ? n.children(n.child) : n.children, "Slottable");
  return t.displayName = `${e}.Slottable`, t.__radixId = bt, t;
}
L(Wn, "createSlottable");
var jn = /* @__PURE__ */ L((e, t) => {
  if ("child" in e.props) {
    const n = e.props.child;
    return a.isValidElement(n) ? a.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
  }
  return a.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Et(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      const u = i(...c);
      return o(...c), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
L(Et, "mergeProps");
function Pt(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
L(Pt, "getElementRef");
function wt(e) {
  return a.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === bt;
}
L(wt, "isSlottable");
var Bn = /* @__PURE__ */ Symbol.for("react.lazy");
function Te(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Bn && "_payload" in e && St(e._payload);
}
L(Te, "isLazyComponent");
function St(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
L(St, "isPromiseLike");
var Un = /* @__PURE__ */ L((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), zn = /* @__PURE__ */ L((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), le = a[" use ".trim().toString()], Hn = Object.defineProperty, Vn = (e, t) => Hn(e, "name", { value: t, configurable: !0 }), Kn = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ae = Kn.reduce((e, t) => {
  const n = /* @__PURE__ */ ze(`Primitive.${t}`), r = a.forwardRef((o, i) => {
    const { asChild: s, ...c } = o, u = s ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ S(u, { ...c, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Ct(e, t) {
  e && je.flushSync(() => e.dispatchEvent(t));
}
Vn(Ct, "dispatchDiscreteCustomEvent");
var Yn = Object.defineProperty, Xn = (e, t) => Yn(e, "name", { value: t, configurable: !0 });
function G(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => ((...n) => t.current?.(...n)), []);
}
Xn(G, "useCallbackRef");
var Gn = Object.defineProperty, A = (e, t) => Gn(e, "name", { value: t, configurable: !0 }), Me = "dismissableLayer.update", Zn = "dismissableLayer.pointerDownOutside", Qn = "dismissableLayer.focusOutside", nt, Rt = a.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
  // Outside elements that belong to a layer's own dismiss affordance (eg, a
  // dialog overlay). Pressing them should dismiss the layer regardless of
  // whether or not they stop propagation.
  //
  // See https://github.com/radix-ui/primitives/issues/3346
  dismissableSurfaces: /* @__PURE__ */ new Set()
}), qn = /* @__PURE__ */ a.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ A(function(t, n) {
    const {
      disableOutsidePointerEvents: r = !1,
      deferPointerDownOutside: o = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      onFocusOutside: c,
      onInteractOutside: u,
      onDismiss: v,
      ...d
    } = t, l = a.useContext(Rt), [f, g] = a.useState(null), m = f?.ownerDocument ?? globalThis?.document, [, p] = a.useState({}), h = Y(n, g), P = Array.from(l.layers), [y] = [
      ...l.layersWithOutsidePointerEventsDisabled
    ].slice(-1), b = y ? P.indexOf(y) : -1, w = f ? P.indexOf(f) : -1, E = l.layersWithOutsidePointerEventsDisabled.size > 0, C = w >= b, O = a.useRef(!1), I = Ot(
      (R) => {
        s?.(R), u?.(R), R.defaultPrevented || v?.();
      },
      {
        ownerDocument: m,
        deferPointerDownOutside: o,
        isDeferredPointerDownOutsideRef: O,
        dismissableSurfaces: l.dismissableSurfaces,
        shouldHandlePointerDownOutside: a.useCallback(
          (R) => {
            if (!(R instanceof Node))
              return !1;
            const N = [...l.branches].some(
              (T) => T.contains(R)
            );
            return C && !N;
          },
          [l.branches, C]
        )
      }
    ), F = xt((R) => {
      if (o && O.current)
        return;
      const N = R.target;
      [...l.branches].some((Z) => Z.contains(N)) || (c?.(R), u?.(R), R.defaultPrevented || v?.());
    }, m), $ = f ? w === P.length - 1 : !1, D = G((R) => {
      R.key === "Escape" && (i?.(R), !R.defaultPrevented && v && (R.preventDefault(), v()));
    });
    return a.useEffect(() => {
      if ($)
        return m.addEventListener("keydown", D, { capture: !0 }), () => m.removeEventListener("keydown", D, { capture: !0 });
    }, [m, $, D]), a.useEffect(() => {
      if (f)
        return r && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (nt = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(f)), l.layers.add(f), Ie(), () => {
          r && (l.layersWithOutsidePointerEventsDisabled.delete(f), l.layersWithOutsidePointerEventsDisabled.size === 0 && (m.body.style.pointerEvents = nt));
        };
    }, [f, m, r, l]), a.useEffect(() => () => {
      f && (l.layers.delete(f), l.layersWithOutsidePointerEventsDisabled.delete(f), Ie());
    }, [f, l]), a.useEffect(() => {
      const R = /* @__PURE__ */ A(() => p({}), "handleUpdate");
      return document.addEventListener(Me, R), () => document.removeEventListener(Me, R);
    }, []), /* @__PURE__ */ S(
      ae.div,
      {
        ...d,
        ref: h,
        style: {
          pointerEvents: E ? C ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: V(t.onFocusCapture, F.onFocusCapture),
        onBlurCapture: V(t.onBlurCapture, F.onBlurCapture),
        onPointerDownCapture: V(
          t.onPointerDownCapture,
          I.onPointerDownCapture
        )
      }
    );
  }, "DismissableLayer")
);
function Jn() {
  const e = a.useContext(Rt), [t, n] = a.useState(null);
  return a.useEffect(() => {
    if (t)
      return e.dismissableSurfaces.add(t), () => {
        e.dismissableSurfaces.delete(t);
      };
  }, [t, e.dismissableSurfaces]), n;
}
A(Jn, "useDismissableLayerSurface");
var er = /* @__PURE__ */ A(() => !0, "IS_TRUE");
function Ot(e, t) {
  const {
    ownerDocument: n = globalThis?.document,
    deferPointerDownOutside: r = !1,
    isDeferredPointerDownOutsideRef: o,
    dismissableSurfaces: i,
    shouldHandlePointerDownOutside: s = er
  } = t, c = G(e), u = a.useRef(!1), v = a.useRef(!1), d = a.useRef(/* @__PURE__ */ new Map()), l = a.useRef(() => {
  });
  return a.useEffect(() => {
    function f() {
      v.current = !1, o.current = !1, d.current.clear();
    }
    A(f, "resetOutsideInteraction");
    function g() {
      return Array.from(d.current.values()).some(Boolean);
    }
    A(g, "isOutsideInteractionIntercepted");
    function m(b) {
      if (!v.current)
        return;
      const w = b.target;
      w instanceof Node && [...i].some((C) => C.contains(w)) || d.current.set(b.type, !0), b.type === "click" && window.setTimeout(() => {
        v.current && l.current();
      }, 0);
    }
    A(m, "handleInteractionCapture");
    function p(b) {
      v.current && d.current.set(b.type, !1);
    }
    A(p, "handleInteractionBubble");
    const h = /* @__PURE__ */ A((b) => {
      if (b.target && !u.current) {
        let w = function() {
          n.removeEventListener("click", l.current);
          const C = g();
          f(), C || He(
            Zn,
            c,
            E,
            { discrete: !0 }
          );
        };
        if (A(w, "handleAndDispatchPointerDownOutsideEvent"), !s(b.target)) {
          n.removeEventListener("click", l.current), f(), u.current = !1;
          return;
        }
        const E = { originalEvent: b };
        v.current = !0, o.current = r && b.button === 0, d.current.clear(), !r || b.button !== 0 ? w() : (n.removeEventListener("click", l.current), l.current = w, n.addEventListener("click", l.current, { once: !0 }));
      } else
        n.removeEventListener("click", l.current), f();
      u.current = !1;
    }, "handlePointerDown"), P = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const b of P)
      n.addEventListener(b, m, !0), n.addEventListener(b, p);
    const y = window.setTimeout(() => {
      n.addEventListener("pointerdown", h);
    }, 0);
    return () => {
      window.clearTimeout(y), n.removeEventListener("pointerdown", h), n.removeEventListener("click", l.current);
      for (const b of P)
        n.removeEventListener(b, m, !0), n.removeEventListener(b, p);
    };
  }, [
    n,
    c,
    r,
    o,
    i,
    s
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: /* @__PURE__ */ A(() => u.current = !0, "onPointerDownCapture")
  };
}
A(Ot, "usePointerDownOutside");
function xt(e, t = globalThis?.document) {
  const n = G(e), r = a.useRef(!1);
  return a.useEffect(() => {
    const o = /* @__PURE__ */ A((i) => {
      i.target && !r.current && He(Qn, n, { originalEvent: i }, {
        discrete: !1
      });
    }, "handleFocus");
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: /* @__PURE__ */ A(() => r.current = !0, "onFocusCapture"),
    onBlurCapture: /* @__PURE__ */ A(() => r.current = !1, "onBlurCapture")
  };
}
A(xt, "useFocusOutside");
function Ie() {
  const e = new CustomEvent(Me);
  document.dispatchEvent(e);
}
A(Ie, "dispatchUpdate");
function He(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ct(o, i) : o.dispatchEvent(i);
}
A(He, "handleAndDispatchCustomEvent");
var tr = Object.defineProperty, Ve = (e, t) => tr(e, "name", { value: t, configurable: !0 }), fe = 0, q = null;
function nr(e) {
  return Ke(), e.children;
}
Ve(nr, "FocusGuards");
function Ke() {
  a.useEffect(() => {
    q || (q = { start: Fe(), end: Fe() });
    const { start: e, end: t } = q;
    return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), fe++, () => {
      fe === 1 && (q?.start.remove(), q?.end.remove(), q = null), fe = Math.max(0, fe - 1);
    };
  }, []);
}
Ve(Ke, "useFocusGuards");
function Fe() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Ve(Fe, "createFocusGuard");
var rr = Object.defineProperty, _ = (e, t) => rr(e, "name", { value: t, configurable: !0 }), Se = "focusScope.autoFocusOnMount", Ce = "focusScope.autoFocusOnUnmount", rt = { bubbles: !1, cancelable: !0 }, or = /* @__PURE__ */ a.forwardRef(
  /* @__PURE__ */ _(function(t, n) {
    const {
      loop: r = !1,
      trapped: o = !1,
      onMountAutoFocus: i,
      onUnmountAutoFocus: s,
      ...c
    } = t, [u, v] = a.useState(null), d = G(i), l = G(s), f = a.useRef(null), g = Y(n, v), m = a.useRef({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }).current;
    a.useEffect(() => {
      if (o) {
        let h = function(w) {
          if (m.paused || !u) return;
          const E = w.target;
          u.contains(E) ? f.current = E : z(f.current, { select: !0 });
        }, P = function(w) {
          if (m.paused || !u) return;
          const E = w.relatedTarget;
          E !== null && (u.contains(E) || z(f.current, { select: !0 }));
        }, y = function(w) {
          if (document.activeElement === document.body)
            for (const C of w)
              C.removedNodes.length > 0 && z(u);
        };
        _(h, "handleFocusIn"), _(P, "handleFocusOut"), _(y, "handleMutations"), document.addEventListener("focusin", h), document.addEventListener("focusout", P);
        const b = new MutationObserver(y);
        return u && b.observe(u, { childList: !0, subtree: !0 }), () => {
          document.removeEventListener("focusin", h), document.removeEventListener("focusout", P), b.disconnect();
        };
      }
    }, [o, u, m.paused]), a.useEffect(() => {
      if (u) {
        ot.add(m);
        const h = document.activeElement;
        if (!u.contains(h)) {
          const y = new CustomEvent(Se, rt);
          u.addEventListener(Se, d), u.dispatchEvent(y), y.defaultPrevented || (At(Mt(Ye(u)), { select: !0 }), document.activeElement === h && z(u));
        }
        return () => {
          u.removeEventListener(Se, d), setTimeout(() => {
            const y = new CustomEvent(Ce, rt);
            u.addEventListener(Ce, l), u.dispatchEvent(y), y.defaultPrevented || z(h ?? document.body, { select: !0 }), u.removeEventListener(Ce, l), ot.remove(m);
          }, 0);
        };
      }
    }, [u, d, l, m]);
    const p = a.useCallback(
      (h) => {
        if (!r && !o || m.paused) return;
        const P = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, y = document.activeElement;
        if (P && y) {
          const b = h.currentTarget, [w, E] = _t(b);
          w && E ? !h.shiftKey && y === E ? (h.preventDefault(), r && z(w, { select: !0 })) : h.shiftKey && y === w && (h.preventDefault(), r && z(E, { select: !0 })) : y === b && h.preventDefault();
        }
      },
      [r, o, m.paused]
    );
    return /* @__PURE__ */ S(ae.div, { tabIndex: -1, ...c, ref: g, onKeyDown: p });
  }, "FocusScope")
);
function At(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (z(r, { select: t }), document.activeElement !== n) return;
}
_(At, "focusFirst");
function _t(e) {
  const t = Ye(e), n = ke(t, e), r = ke(t.reverse(), e);
  return [n, r];
}
_(_t, "getTabbableEdges");
function Ye(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: /* @__PURE__ */ _((r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }, "acceptNode")
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
_(Ye, "getTabbableCandidates");
function ke(e, t) {
  const n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
  for (const r of e)
    if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : Dt(r, { upTo: t })))
      return r;
}
_(ke, "findVisible");
function Dt(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
_(Dt, "isHidden");
function Nt(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
_(Nt, "isSelectableInput");
function z(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Nt(e) && t && e.select();
  }
}
_(z, "focus");
var ot = Tt();
function Tt() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Le(e, t), e.unshift(t);
    },
    remove(t) {
      e = Le(e, t), e[0]?.resume();
    }
  };
}
_(Tt, "createFocusScopesStack");
function Le(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
_(Le, "arrayRemove");
function Mt(e) {
  return e.filter((t) => t.tagName !== "A");
}
_(Mt, "removeLinks");
var U = globalThis?.document ? a.useLayoutEffect : () => {
}, ar = Object.defineProperty, ir = (e, t) => ar(e, "name", { value: t, configurable: !0 }), sr = a[" useId ".trim().toString()] || (() => {
}), cr = 0;
function It(e) {
  const [t, n] = a.useState(sr());
  return U(() => {
    e || n((r) => r ?? String(cr++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
ir(It, "useId");
var ur = typeof document < "u", lr = function() {
}, he = ur ? wn : lr;
function be(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!be(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !be(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ft(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function at(e, t) {
  const n = Ft(e);
  return Math.round(t * n) / n;
}
function Re(e) {
  const t = a.useRef(e);
  return he(() => {
    t.current = e;
  }), t;
}
function fr(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: u,
    open: v
  } = e, [d, l] = a.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, g] = a.useState(r);
  be(f, r) || g(r);
  const [m, p] = a.useState(null), [h, P] = a.useState(null), y = a.useCallback((x) => {
    x !== C.current && (C.current = x, p(x));
  }, []), b = a.useCallback((x) => {
    x !== O.current && (O.current = x, P(x));
  }, []), w = i || m, E = s || h, C = a.useRef(null), O = a.useRef(null), I = a.useRef(d), F = u != null, $ = Re(u), D = Re(o), R = Re(v), N = a.useCallback(() => {
    if (!C.current || !O.current)
      return;
    const x = {
      placement: t,
      strategy: n,
      middleware: f
    };
    D.current && (x.platform = D.current), Cn(C.current, O.current, x).then((k) => {
      const j = {
        ...k,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: R.current !== !1
      };
      T.current && !be(I.current, j) && (I.current = j, je.flushSync(() => {
        l(j);
      }));
    });
  }, [f, t, n, D, R]);
  he(() => {
    v === !1 && I.current.isPositioned && (I.current.isPositioned = !1, l((x) => ({
      ...x,
      isPositioned: !1
    })));
  }, [v]);
  const T = a.useRef(!1);
  he(() => (T.current = !0, () => {
    T.current = !1;
  }), []), he(() => {
    if (w && (C.current = w), E && (O.current = E), w && E) {
      if ($.current)
        return $.current(w, E, N);
      N();
    }
  }, [w, E, N, $, F]);
  const Z = a.useMemo(() => ({
    reference: C,
    floating: O,
    setReference: y,
    setFloating: b
  }), [y, b]), W = a.useMemo(() => ({
    reference: w,
    floating: E
  }), [w, E]), Q = a.useMemo(() => {
    const x = {
      position: n,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return x;
    const k = at(W.floating, d.x), j = at(W.floating, d.y);
    return c ? {
      ...x,
      transform: "translate(" + k + "px, " + j + "px)",
      ...Ft(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: k,
      top: j
    };
  }, [n, c, W.floating, d.x, d.y]);
  return a.useMemo(() => ({
    ...d,
    update: N,
    refs: Z,
    elements: W,
    floatingStyles: Q
  }), [d, N, Z, W, Q]);
}
const dr = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? tt({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? tt({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, pr = (e, t) => {
  const n = Rn(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, vr = (e, t) => {
  const n = On(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, mr = (e, t) => ({
  fn: Dn(e).fn,
  options: [e, t]
}), hr = (e, t) => {
  const n = xn(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, gr = (e, t) => {
  const n = An(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, yr = (e, t) => {
  const n = _n(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, br = (e, t) => {
  const n = dr(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var Er = Object.defineProperty, Pr = (e, t) => Er(e, "name", { value: t, configurable: !0 });
function kt(e) {
  const [t, n] = a.useState(void 0);
  return U(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, c;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, v = Array.isArray(u) ? u[0] : u;
          s = v.inlineSize, c = v.blockSize;
        } else
          s = e.offsetWidth, c = e.offsetHeight;
        n({ width: s, height: c });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
Pr(kt, "useSize");
var wr = Object.defineProperty, K = (e, t) => wr(e, "name", { value: t, configurable: !0 }), Lt = "Popper", [$t, Wt] = /* @__PURE__ */ Ue(Lt), [Sr, jt] = $t(Lt), Cr = /* @__PURE__ */ K((e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = a.useState(null), [i, s] = a.useState(void 0);
  return /* @__PURE__ */ S(
    Sr,
    {
      scope: t,
      anchor: r,
      onAnchorChange: o,
      placementState: i,
      setPlacementState: s,
      children: n
    }
  );
}, "Popper"), Rr = "PopperAnchor", Or = /* @__PURE__ */ a.forwardRef(
  /* @__PURE__ */ K(function(t, n) {
    const { __scopePopper: r, virtualRef: o, ...i } = t, s = jt(Rr, r), c = a.useRef(null), u = s.onAnchorChange, v = a.useCallback(
      (p) => {
        c.current = p, p && u(p);
      },
      [u]
    ), d = Y(n, v), l = a.useRef(null);
    a.useEffect(() => {
      if (!o)
        return;
      const p = l.current;
      l.current = o.current, p !== l.current && u(l.current);
    });
    const f = s.placementState && Ee(s.placementState), g = f?.[0], m = f?.[1];
    return o ? null : /* @__PURE__ */ S(
      ae.div,
      {
        "data-radix-popper-side": g,
        "data-radix-popper-align": m,
        ...i,
        ref: d
      }
    );
  }, "PopperAnchor")
), Bt = "PopperContent", [xr, Zo] = $t(Bt), Ar = /* @__PURE__ */ a.forwardRef(
  /* @__PURE__ */ K(function(t, n) {
    const {
      __scopePopper: r,
      side: o = "bottom",
      sideOffset: i = 0,
      align: s = "center",
      alignOffset: c = 0,
      arrowPadding: u = 0,
      avoidCollisions: v = !0,
      collisionBoundary: d = [],
      collisionPadding: l = 0,
      sticky: f = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: p,
      ...h
    } = t, P = jt(Bt, r), [y, b] = a.useState(null), w = Y(n, b), [E, C] = a.useState(null), O = kt(E), I = O?.width ?? 0, F = O?.height ?? 0, $ = o + (s !== "center" ? "-" + s : ""), D = typeof l == "number" ? l : { top: 0, right: 0, bottom: 0, left: 0, ...l }, R = Array.isArray(d) ? d : [d], N = R.length > 0, T = {
      padding: D,
      boundary: R.filter(Ut),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: N
    }, { refs: Z, floatingStyles: W, placement: Q, isPositioned: x, middlewareData: k } = fr({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: $,
      whileElementsMounted: /* @__PURE__ */ K((...we) => Nn(...we, {
        animationFrame: m === "always"
      }), "whileElementsMounted"),
      elements: {
        reference: P.anchor
      },
      middleware: [
        pr({ mainAxis: i + F, alignmentAxis: c }),
        v && vr({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? mr() : void 0,
          ...T
        }),
        v && hr({ ...T }),
        gr({
          ...T,
          apply: /* @__PURE__ */ K(({ elements: we, rects: et, availableWidth: gn, availableHeight: yn }) => {
            const { width: bn, height: En } = et.reference, ue = we.floating.style;
            ue.setProperty("--radix-popper-available-width", `${gn}px`), ue.setProperty("--radix-popper-available-height", `${yn}px`), ue.setProperty("--radix-popper-anchor-width", `${bn}px`), ue.setProperty("--radix-popper-anchor-height", `${En}px`);
          }, "apply")
        }),
        E && br({ element: E, padding: u }),
        _r({ arrowWidth: I, arrowHeight: F }),
        g && yr({
          strategy: "referenceHidden",
          ...T,
          // `hide` detects whether the anchor (reference) is clipped, so when
          // no explicit `collisionBoundary` is set we fall back to Floating
          // UI's default clipping ancestors (e.g. a scrollable menu). This
          // lets an occluded submenu hide once its anchor scrolls out of view
          // (#3237). The collision/size middlewares deliberately keep the
          // viewport-based default to avoid clamping content rendered inside
          // transformed or overflow-clipping portal containers.
          boundary: N ? T.boundary : void 0
        })
      ]
    }), j = P.setPlacementState;
    U(() => (j(Q), () => {
      j(void 0);
    }), [Q, j]);
    const [Qe, qe] = Ee(Q), Je = G(p);
    U(() => {
      x && Je?.();
    }, [x, Je]);
    const dn = k.arrow?.x, pn = k.arrow?.y, vn = k.arrow?.centerOffset !== 0, [mn, hn] = a.useState();
    return U(() => {
      y && hn(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ S(
      "div",
      {
        ref: Z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: x ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: mn,
          "--radix-popper-transform-origin": [
            k.transformOrigin?.x,
            k.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...k.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ S(
          xr,
          {
            scope: r,
            placedSide: Qe,
            placedAlign: qe,
            onArrowChange: C,
            arrowX: dn,
            arrowY: pn,
            shouldHideArrow: vn,
            children: /* @__PURE__ */ S(
              ae.div,
              {
                "data-side": Qe,
                "data-align": qe,
                ...h,
                ref: w,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all
                  // measurements done) we prevent animations so that users'
                  // animations don't kick in too early from the wrong sides.
                  animation: x ? h.style?.animation : "none"
                }
              }
            )
          }
        )
      }
    );
  }, "PopperContent")
);
function Ut(e) {
  return e !== null;
}
K(Ut, "isNotNull");
var _r = /* @__PURE__ */ K((e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: o } = t, s = o.arrow?.centerOffset !== 0, c = s ? 0 : e.arrowWidth, u = s ? 0 : e.arrowHeight, [v, d] = Ee(n), l = { start: "0%", center: "50%", end: "100%" }[d], f = (o.arrow?.x ?? 0) + c / 2, g = (o.arrow?.y ?? 0) + u / 2;
    let m = "", p = "";
    return v === "bottom" ? (m = s ? l : `${f}px`, p = `${-u}px`) : v === "top" ? (m = s ? l : `${f}px`, p = `${r.floating.height + u}px`) : v === "right" ? (m = `${-u}px`, p = s ? l : `${g}px`) : v === "left" && (m = `${r.floating.width + u}px`, p = s ? l : `${g}px`), { data: { x: m, y: p } };
  }
}), "transformOrigin");
function Ee(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
K(Ee, "getSideAndAlignFromPlacement");
var Dr = Cr, Nr = Or, Tr = Ar, Mr = Object.defineProperty, Ir = (e, t) => Mr(e, "name", { value: t, configurable: !0 }), Fr = /* @__PURE__ */ a.forwardRef(
  /* @__PURE__ */ Ir(function(t, n) {
    const { container: r, ...o } = t, [i, s] = a.useState(!1);
    U(() => s(!0), []);
    const c = r || i && globalThis?.document?.body;
    return c ? je.createPortal(/* @__PURE__ */ S(ae.div, { ...o, ref: n }), c) : null;
  }, "Portal")
), kr = Object.defineProperty, H = (e, t) => kr(e, "name", { value: t, configurable: !0 });
function zt(e, t) {
  return a.useReducer((n, r) => t[n][r] ?? n, e);
}
H(zt, "useStateMachine");
var Ht = /* @__PURE__ */ H((e) => {
  const { present: t, children: n } = e, r = Vt(t), o = typeof n == "function" ? n({ present: r.isPresent }) : a.Children.only(n), i = Kt(r.ref, Yt(o));
  return typeof n == "function" || r.isPresent ? a.cloneElement(o, { ref: i }) : null;
}, "Presence");
function Vt(e) {
  const [t, n] = a.useState(), r = a.useRef(null), o = a.useRef(e), i = a.useRef("none"), s = a.useRef(void 0), c = e ? "mounted" : "unmounted", [u, v] = zt(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return a.useEffect(() => {
    u === "mounted" ? (i.current = s.current ?? ne(r.current), s.current = void 0) : i.current = "none";
  }, [u]), U(() => {
    const d = r.current, l = o.current;
    if (l !== e) {
      const g = i.current, m = ne(d);
      e ? (s.current = m, v("MOUNT")) : m === "none" || d?.display === "none" ? v("UNMOUNT") : v(l && g !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, v]), U(() => {
    if (t) {
      let d;
      const l = t.ownerDocument.defaultView ?? window, f = /* @__PURE__ */ H((m) => {
        const h = ne(r.current).includes(CSS.escape(m.animationName));
        if (m.target === t && h && (v("ANIMATION_END"), !o.current)) {
          const P = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", d = l.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = P);
          });
        }
      }, "handleAnimationEnd"), g = /* @__PURE__ */ H((m) => {
        m.target === t && (i.current = ne(r.current));
      }, "handleAnimationStart");
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        l.clearTimeout(d), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      v("ANIMATION_END");
  }, [t, v]), {
    isPresent: ["mounted", "unmountSuspended"].includes(u),
    ref: a.useCallback((d) => {
      if (d) {
        const l = getComputedStyle(d);
        r.current = l, s.current = ne(l);
      } else
        r.current = null;
      n(d);
    }, [])
  };
}
H(Vt, "usePresence");
function $e(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
H($e, "setRef");
function Kt(...e) {
  const t = a.useRef(e);
  return t.current = e, a.useCallback((n) => {
    const r = t.current;
    let o = !1;
    const i = r.map((s) => {
      const c = $e(s, n);
      return !o && typeof c == "function" && (o = !0), c;
    });
    if (o)
      return () => {
        for (let s = 0; s < i.length; s++) {
          const c = i[s];
          typeof c == "function" ? c() : $e(r[s], null);
        }
      };
  }, []);
}
H(Kt, "useStableComposedRefs");
function ne(e) {
  return e?.animationName || "none";
}
H(ne, "getAnimationName");
function Yt(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
H(Yt, "getElementRef");
var Lr = Object.defineProperty, $r = (e, t) => Lr(e, "name", { value: t, configurable: !0 }), it = a[" useEffectEvent ".trim().toString()], st = a[" useInsertionEffect ".trim().toString()];
function Xt(e) {
  if (typeof it == "function")
    return it(e);
  const t = a.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return typeof st == "function" ? st(() => {
    t.current = e;
  }) : U(() => {
    t.current = e;
  }), a.useMemo(() => ((...n) => t.current?.(...n)), []);
}
$r(Xt, "useEffectEvent");
var Wr = Object.defineProperty, ce = (e, t) => Wr(e, "name", { value: t, configurable: !0 }), jr = a[" useInsertionEffect ".trim().toString()] || U;
function Gt({
  prop: e,
  defaultProp: t,
  onChange: n = /* @__PURE__ */ ce(() => {
  }, "onChange"),
  caller: r
}) {
  const [o, i, s] = Zt({
    defaultProp: t,
    onChange: n
  }), c = e !== void 0, u = c ? e : o, v = a.useCallback(
    (d) => {
      if (c) {
        const l = Qt(d) ? d(e) : d;
        l !== e && s.current?.(l);
      } else
        i(d);
    },
    [c, e, i, s]
  );
  return [u, v];
}
ce(Gt, "useControllableState");
function Zt({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = a.useState(e), o = a.useRef(n), i = a.useRef(t);
  return jr(() => {
    i.current = t;
  }, [t]), a.useEffect(() => {
    o.current !== n && (i.current?.(n), o.current = n);
  }, [n, o]), [n, r, i];
}
ce(Zt, "useUncontrolledState");
function Qt(e) {
  return typeof e == "function";
}
ce(Qt, "isFunction");
var ct = /* @__PURE__ */ Symbol("RADIX:SYNC_STATE");
function Br(e, t, n, r) {
  const { prop: o, defaultProp: i, onChange: s, caller: c } = t, u = o !== void 0, v = Xt(s), d = [{ ...n, state: i }];
  r && d.push(r);
  const [l, f] = a.useReducer(
    (h, P) => {
      if (P.type === ct)
        return { ...h, state: P.state };
      const y = e(h, P);
      return u && !Object.is(y.state, h.state) && v(y.state), y;
    },
    ...d
  ), g = l.state, m = a.useRef(g);
  a.useEffect(() => {
    m.current !== g && (m.current = g, u || v(g));
  }, [g, m, u]);
  const p = a.useMemo(() => o !== void 0 ? { ...l, state: o } : l, [l, o]);
  return a.useEffect(() => {
    u && !Object.is(o, l.state) && f({ type: ct, state: o });
  }, [o, l.state, u]), [p, f];
}
ce(Br, "useControllableStateReducer");
var Ur = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, J = /* @__PURE__ */ new WeakMap(), de = /* @__PURE__ */ new WeakMap(), pe = {}, Oe = 0, qt = function(e) {
  return e && (e.host || qt(e.parentNode));
}, zr = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = qt(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Hr = function(e, t, n, r) {
  var o = zr(t, Array.isArray(e) ? e : [e]);
  pe[n] || (pe[n] = /* @__PURE__ */ new WeakMap());
  var i = pe[n], s = [], c = /* @__PURE__ */ new Set(), u = new Set(o), v = function(l) {
    !l || c.has(l) || (c.add(l), v(l.parentNode));
  };
  o.forEach(v);
  var d = function(l) {
    !l || u.has(l) || Array.prototype.forEach.call(l.children, function(f) {
      if (c.has(f))
        d(f);
      else
        try {
          var g = f.getAttribute(r), m = g !== null && g !== "false", p = (J.get(f) || 0) + 1, h = (i.get(f) || 0) + 1;
          J.set(f, p), i.set(f, h), s.push(f), p === 1 && m && de.set(f, !0), h === 1 && f.setAttribute(n, "true"), m || f.setAttribute(r, "true");
        } catch (P) {
          console.error("aria-hidden: cannot operate on ", f, P);
        }
    });
  };
  return d(t), c.clear(), Oe++, function() {
    s.forEach(function(l) {
      var f = J.get(l) - 1, g = i.get(l) - 1;
      J.set(l, f), i.set(l, g), f || (de.has(l) || l.removeAttribute(r), de.delete(l)), g || l.removeAttribute(n);
    }), Oe--, Oe || (J = /* @__PURE__ */ new WeakMap(), J = /* @__PURE__ */ new WeakMap(), de = /* @__PURE__ */ new WeakMap(), pe = {});
  };
}, Vr = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = Ur(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), Hr(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, B = function() {
  return B = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, B.apply(this, arguments);
};
function Jt(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Kr(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var ge = "right-scroll-bar-position", ye = "width-before-scroll-bar", Yr = "with-scroll-bars-hidden", Xr = "--removed-body-scroll-bar-size";
function xe(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Gr(e, t) {
  var n = Sn(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Zr = typeof window < "u" ? a.useLayoutEffect : a.useEffect, ut = /* @__PURE__ */ new WeakMap();
function Qr(e, t) {
  var n = Gr(null, function(r) {
    return e.forEach(function(o) {
      return xe(o, r);
    });
  });
  return Zr(function() {
    var r = ut.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(c) {
        i.has(c) || xe(c, null);
      }), i.forEach(function(c) {
        o.has(c) || xe(c, s);
      });
    }
    ut.set(n, e);
  }, [e]), n;
}
function qr(e) {
  return e;
}
function Jr(e, t) {
  t === void 0 && (t = qr);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(c) {
          return c !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), s = n;
      }
      var u = function() {
        var d = s;
        s = [], d.forEach(i);
      }, v = function() {
        return Promise.resolve().then(u);
      };
      v(), n = {
        push: function(d) {
          s.push(d), v();
        },
        filter: function(d) {
          return s = s.filter(d), n;
        }
      };
    }
  };
  return o;
}
function eo(e) {
  e === void 0 && (e = {});
  var t = Jr(null);
  return t.options = B({ async: !0, ssr: !1 }, e), t;
}
var en = function(e) {
  var t = e.sideCar, n = Jt(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return a.createElement(r, B({}, n));
};
en.isSideCarExport = !0;
function to(e, t) {
  return e.useMedium(t), en;
}
var tn = eo(), Ae = function() {
}, Pe = a.forwardRef(function(e, t) {
  var n = a.useRef(null), r = a.useState({
    onScrollCapture: Ae,
    onWheelCapture: Ae,
    onTouchMoveCapture: Ae
  }), o = r[0], i = r[1], s = e.forwardProps, c = e.children, u = e.className, v = e.removeScrollBar, d = e.enabled, l = e.shards, f = e.sideCar, g = e.noRelative, m = e.noIsolation, p = e.inert, h = e.allowPinchZoom, P = e.as, y = P === void 0 ? "div" : P, b = e.gapMode, w = Jt(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = f, C = Qr([n, t]), O = B(B({}, w), o);
  return a.createElement(
    a.Fragment,
    null,
    d && a.createElement(E, { sideCar: tn, removeScrollBar: v, shards: l, noRelative: g, noIsolation: m, inert: p, setCallbacks: i, allowPinchZoom: !!h, lockRef: n, gapMode: b }),
    s ? a.cloneElement(a.Children.only(c), B(B({}, O), { ref: C })) : a.createElement(y, B({}, O, { className: u, ref: C }), c)
  );
});
Pe.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Pe.classNames = {
  fullWidth: ye,
  zeroRight: ge
};
var no = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ro() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = no();
  return t && e.setAttribute("nonce", t), e;
}
function oo(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ao(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var io = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = ro()) && (oo(t, n), ao(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, so = function() {
  var e = io();
  return function(t, n) {
    a.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, nn = function() {
  var e = so(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, co = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _e = function(e) {
  return parseInt(e || "", 10) || 0;
}, uo = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_e(n), _e(r), _e(o)];
}, lo = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return co;
  var t = uo(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, fo = nn(), re = "data-scroll-locked", po = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Yr, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(re, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ge, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(ye, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(ge, " .").concat(ge, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(ye, " .").concat(ye, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(re, `] {
    `).concat(Xr, ": ").concat(c, `px;
  }
`);
}, lt = function() {
  var e = parseInt(document.body.getAttribute(re) || "0", 10);
  return isFinite(e) ? e : 0;
}, vo = function() {
  a.useEffect(function() {
    return document.body.setAttribute(re, (lt() + 1).toString()), function() {
      var e = lt() - 1;
      e <= 0 ? document.body.removeAttribute(re) : document.body.setAttribute(re, e.toString());
    };
  }, []);
}, mo = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  vo();
  var i = a.useMemo(function() {
    return lo(o);
  }, [o]);
  return a.createElement(fo, { styles: po(i, !t, o, n ? "" : "!important") });
}, We = !1;
if (typeof window < "u")
  try {
    var ve = Object.defineProperty({}, "passive", {
      get: function() {
        return We = !0, !0;
      }
    });
    window.addEventListener("test", ve, ve), window.removeEventListener("test", ve, ve);
  } catch {
    We = !1;
  }
var ee = We ? { passive: !1 } : !1, ho = function(e) {
  return e.tagName === "TEXTAREA";
}, rn = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !ho(e) && n[t] === "visible")
  );
}, go = function(e) {
  return rn(e, "overflowY");
}, yo = function(e) {
  return rn(e, "overflowX");
}, ft = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = on(e, r);
    if (o) {
      var i = an(e, r), s = i[1], c = i[2];
      if (s > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, bo = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Eo = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, on = function(e, t) {
  return e === "v" ? go(t) : yo(t);
}, an = function(e, t) {
  return e === "v" ? bo(t) : Eo(t);
}, Po = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, wo = function(e, t, n, r, o) {
  var i = Po(e, window.getComputedStyle(t).direction), s = i * r, c = n.target, u = t.contains(c), v = !1, d = s > 0, l = 0, f = 0;
  do {
    if (!c)
      break;
    var g = an(e, c), m = g[0], p = g[1], h = g[2], P = p - h - i * m;
    (m || P) && on(e, c) && (l += P, f += m);
    var y = c.parentNode;
    c = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !u && c !== document.body || // self content
    u && (t.contains(c) || t === c)
  );
  return (d && Math.abs(l) < 1 || !d && Math.abs(f) < 1) && (v = !0), v;
}, me = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, dt = function(e) {
  return [e.deltaX, e.deltaY];
}, pt = function(e) {
  return e && "current" in e ? e.current : e;
}, So = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Co = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Ro = 0, te = [];
function Oo(e) {
  var t = a.useRef([]), n = a.useRef([0, 0]), r = a.useRef(), o = a.useState(Ro++)[0], i = a.useState(nn)[0], s = a.useRef(e);
  a.useEffect(function() {
    s.current = e;
  }, [e]), a.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var p = Kr([e.lockRef.current], (e.shards || []).map(pt), !0).filter(Boolean);
      return p.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), p.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = a.useCallback(function(p, h) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !s.current.allowPinchZoom;
    var P = me(p), y = n.current, b = "deltaX" in p ? p.deltaX : y[0] - P[0], w = "deltaY" in p ? p.deltaY : y[1] - P[1], E, C = p.target, O = Math.abs(b) > Math.abs(w) ? "h" : "v";
    if ("touches" in p && O === "h" && C.type === "range")
      return !1;
    var I = window.getSelection(), F = I && I.anchorNode, $ = F ? F === C || F.contains(C) : !1;
    if ($)
      return !1;
    var D = ft(O, C);
    if (!D)
      return !0;
    if (D ? E = O : (E = O === "v" ? "h" : "v", D = ft(O, C)), !D)
      return !1;
    if (!r.current && "changedTouches" in p && (b || w) && (r.current = E), !E)
      return !0;
    var R = r.current || E;
    return wo(R, h, p, R === "h" ? b : w);
  }, []), u = a.useCallback(function(p) {
    var h = p;
    if (!(!te.length || te[te.length - 1] !== i)) {
      var P = "deltaY" in h ? dt(h) : me(h), y = t.current.filter(function(E) {
        return E.name === h.type && (E.target === h.target || h.target === E.shadowParent) && So(E.delta, P);
      })[0];
      if (y && y.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!y) {
        var b = (s.current.shards || []).map(pt).filter(Boolean).filter(function(E) {
          return E.contains(h.target);
        }), w = b.length > 0 ? c(h, b[0]) : !s.current.noIsolation;
        w && h.cancelable && h.preventDefault();
      }
    }
  }, []), v = a.useCallback(function(p, h, P, y) {
    var b = { name: p, delta: h, target: P, should: y, shadowParent: xo(P) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== b;
      });
    }, 1);
  }, []), d = a.useCallback(function(p) {
    n.current = me(p), r.current = void 0;
  }, []), l = a.useCallback(function(p) {
    v(p.type, dt(p), p.target, c(p, e.lockRef.current));
  }, []), f = a.useCallback(function(p) {
    v(p.type, me(p), p.target, c(p, e.lockRef.current));
  }, []);
  a.useEffect(function() {
    return te.push(i), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", u, ee), document.addEventListener("touchmove", u, ee), document.addEventListener("touchstart", d, ee), function() {
      te = te.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", u, ee), document.removeEventListener("touchmove", u, ee), document.removeEventListener("touchstart", d, ee);
    };
  }, []);
  var g = e.removeScrollBar, m = e.inert;
  return a.createElement(
    a.Fragment,
    null,
    m ? a.createElement(i, { styles: Co(o) }) : null,
    g ? a.createElement(mo, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function xo(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Ao = to(tn, Oo);
var sn = a.forwardRef(function(e, t) {
  return a.createElement(Pe, B({}, e, { ref: t, sideCar: Ao }));
});
sn.classNames = Pe.classNames;
var _o = Object.defineProperty, X = (e, t) => _o(e, "name", { value: t, configurable: !0 }), Xe = "Popover", [cn, Qo] = /* @__PURE__ */ Ue(Xe, [
  Wt
]), Ge = Wt(), [Do, ie] = cn(Xe), No = /* @__PURE__ */ X((e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !1
  } = e, c = Ge(t), u = a.useRef(null), [v, d] = a.useState(!1), [l, f] = Gt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Xe
  });
  return /* @__PURE__ */ S(Dr, { ...c, children: /* @__PURE__ */ S(
    Do,
    {
      scope: t,
      contentId: It(),
      triggerRef: u,
      open: l,
      onOpenChange: f,
      onOpenToggle: a.useCallback(() => f((g) => !g), [f]),
      hasCustomAnchor: v,
      onCustomAnchorAdd: a.useCallback(() => d(!0), []),
      onCustomAnchorRemove: a.useCallback(() => d(!1), []),
      modal: s,
      children: n
    }
  ) });
}, "Popover"), To = "PopoverTrigger", Mo = /* @__PURE__ */ a.forwardRef(
  /* @__PURE__ */ X(function(t, n) {
    const { __scopePopover: r, ...o } = t, i = ie(To, r), s = Ge(r), c = Y(n, i.triggerRef), u = /* @__PURE__ */ S(
      ae.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": Ze(i.open),
        ...o,
        ref: c,
        onClick: V(t.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? u : /* @__PURE__ */ S(Nr, { asChild: !0, ...s, children: u });
  }, "PopoverTrigger")
), un = "PopoverPortal", [Io, Fo] = cn(un, {
  forceMount: void 0
}), ko = /* @__PURE__ */ X((e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = ie(un, t);
  return /* @__PURE__ */ S(Io, { scope: t, forceMount: n, children: /* @__PURE__ */ S(Ht, { present: n || i.open, children: /* @__PURE__ */ S(Fr, { asChild: !0, container: o, children: r }) }) });
}, "PopoverPortal"), se = "PopoverContent", Lo = /* @__PURE__ */ a.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ X(function(t, n) {
    const r = Fo(se, t.__scopePopover), { forceMount: o = r.forceMount, ...i } = t, s = ie(se, t.__scopePopover);
    return /* @__PURE__ */ S(Ht, { present: o || s.open, children: s.modal ? /* @__PURE__ */ S(Wo, { ...i, ref: n }) : /* @__PURE__ */ S(jo, { ...i, ref: n }) });
  }, "PopoverContent")
), $o = /* @__PURE__ */ ze("PopoverContent.RemoveScroll"), Wo = /* @__PURE__ */ a.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ X(function(t, n) {
    const r = ie(se, t.__scopePopover), o = a.useRef(null), i = Y(n, o), s = a.useRef(!1);
    return a.useEffect(() => {
      const c = o.current;
      if (c) return Vr(c);
    }, []), /* @__PURE__ */ S(sn, { as: $o, allowPinchZoom: !0, children: /* @__PURE__ */ S(
      ln,
      {
        ...t,
        ref: i,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: V(t.onCloseAutoFocus, (c) => {
          c.preventDefault(), s.current || r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: V(
          t.onPointerDownOutside,
          (c) => {
            const u = c.detail.originalEvent, v = u.button === 0 && u.ctrlKey === !0, d = u.button === 2 || v;
            s.current = d;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: V(
          t.onFocusOutside,
          (c) => c.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }, "PopoverContentModal")
), jo = /* @__PURE__ */ a.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ X(function(t, n) {
    const r = ie(se, t.__scopePopover), o = a.useRef(!1), i = a.useRef(!1);
    return /* @__PURE__ */ S(
      ln,
      {
        ...t,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          t.onCloseAutoFocus?.(s), s.defaultPrevented || (o.current || r.triggerRef.current?.focus(), s.preventDefault()), o.current = !1, i.current = !1;
        },
        onInteractOutside: (s) => {
          t.onInteractOutside?.(s), s.defaultPrevented || (o.current = !0, s.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const c = s.target;
          r.triggerRef.current?.contains(c) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && i.current && s.preventDefault();
        }
      }
    );
  }, "PopoverContentNonModal")
), ln = /* @__PURE__ */ a.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ X(function(t, n) {
    const {
      __scopePopover: r,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: c,
      onEscapeKeyDown: u,
      onPointerDownOutside: v,
      onFocusOutside: d,
      onInteractOutside: l,
      ...f
    } = t, g = ie(se, r), m = Ge(r);
    return Ke(), /* @__PURE__ */ S(
      or,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: i,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ S(
          qn,
          {
            asChild: !0,
            disableOutsidePointerEvents: c,
            onInteractOutside: l,
            onEscapeKeyDown: u,
            onPointerDownOutside: v,
            onFocusOutside: d,
            onDismiss: () => g.onOpenChange(!1),
            deferPointerDownOutside: !0,
            children: /* @__PURE__ */ S(
              Tr,
              {
                "data-state": Ze(g.open),
                role: "dialog",
                id: g.contentId,
                ...m,
                ...f,
                ref: n,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }, "PopoverContentImpl")
);
function Ze(e) {
  return e ? "open" : "closed";
}
X(Ze, "getState");
var Bo = No, Uo = Mo, zo = ko, fn = Lo;
const qo = Bo, Jo = Uo, Ho = Pn.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ S(zo, { children: /* @__PURE__ */ S(
  fn,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: Tn(
      "z-50 w-72 rounded-md border p-4 text-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 glass-tile",
      e
    ),
    ...r
  }
) }));
Ho.displayName = fn.displayName;
export {
  qo as Popover,
  Ho as PopoverContent,
  Jo as PopoverTrigger
};
